import * as React from "react"

const ChatWithoutQuestion = (props) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.2227 0.75H2.72266C1.73828 0.75 0.972656 1.54297 0.972656 2.5V10.3477C0.972656 11.3047 1.73828 12.0703 2.72266 12.0703H5.34766V14.3672C5.34766 14.6406 5.64844 14.7773 5.86719 14.6133L9.28516 12.0703H13.2227C14.1797 12.0703 14.9727 11.2773 14.9727 10.3477V2.5C14.9727 1.54297 14.207 0.75 13.2227 0.75ZM13.6875 10.375C13.6875 10.6211 13.4688 10.8125 13.25 10.8125H8.875L6.6875 12.4531V10.8125H2.75C2.50391 10.8125 2.3125 10.6211 2.3125 10.375V2.5C2.3125 2.28125 2.50391 2.0625 2.75 2.0625H13.25C13.4688 2.0625 13.6875 2.28125 13.6875 2.5V10.375Z" fill="white"/>
  </svg>

)
export default ChatWithoutQuestion
